var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDotsinimageviwer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_4799_48824)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "#F3F3F3",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 31,
    height: 31,
    rx: 15.5,
    stroke: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.669 11.4174C14.8269 11.4174 14.1666 10.4109 14.1666 9.12567C14.1666 7.84041 14.8269 6.83398 15.669 6.83398C16.5112 6.83398 17.1715 7.84041 17.1715 9.12567C17.1715 10.4109 16.5112 11.4174 15.669 11.4174ZM15.669 7.7146C15.4214 7.7146 15.048 8.27711 15.048 9.12487C15.048 9.97263 15.4222 10.5351 15.669 10.5351C15.9158 10.5351 16.29 9.97263 16.29 9.12487C16.29 8.27711 15.9166 7.7146 15.669 7.7146Z",
    fill: "#1E1850"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.669 17.8334C14.8269 17.8334 14.1666 16.827 14.1666 15.5417C14.1666 14.2564 14.8269 13.25 15.669 13.25C16.5112 13.25 17.1715 14.2564 17.1715 15.5417C17.1715 16.827 16.5112 17.8334 15.669 17.8334ZM15.669 14.1306C15.4214 14.1306 15.048 14.6931 15.048 15.5409C15.048 16.3886 15.4222 16.9512 15.669 16.9512C15.9158 16.9512 16.29 16.3886 16.29 15.5409C16.29 14.6931 15.9166 14.1306 15.669 14.1306Z",
    fill: "#1E1850"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.669 24.2513C14.8269 24.2513 14.1666 23.2449 14.1666 21.9597C14.1666 20.6744 14.8269 19.668 15.669 19.668C16.5112 19.668 17.1715 20.6744 17.1715 21.9597C17.1715 23.2449 16.5112 24.2513 15.669 24.2513ZM15.669 20.5486C15.4214 20.5486 15.048 21.1111 15.048 21.9589C15.048 22.8066 15.4222 23.3691 15.669 23.3691C15.9158 23.3691 16.29 22.8066 16.29 21.9589C16.29 21.1111 15.9166 20.5486 15.669 20.5486Z",
    fill: "#1E1850"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_4799_48824",
    x: -4,
    y: -4,
    width: 40,
    height: 40,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_4799_48824"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_4799_48824",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDotsinimageviwer);
export default __webpack_public_path__ + "static/media/dots in image viwer.7373b38aa06c7be652991fabf8f9d2b7.svg";
export { ForwardRef as ReactComponent };